import { createRouter, createWebHistory } from 'vue-router'
import OrdersPage from '@/views/OrdersPage.vue'
import RequestsPage from '@/views/RequestsPage.vue'

const routes = [
  {
    path: '/requests/:token',
    name: 'requests',
    component: RequestsPage,
  },
  {
    path: '/orders/:token',
    name: 'orders',
    component: OrdersPage,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
